<div class="scst-page">
  <app-header-style-seven></app-header-style-seven>

  <section class="page-shell scst-shell">
    <div class="custom-container">
      <div class="content-shell scst-content-shell">
        <!-- HERO -->
        <header class="page-hero">
          <span class="page-kicker">Equity &amp; Inclusion</span>
          <h1>SC / ST Committee</h1>
          <p>
            Committee constituted in line with the Scheduled Castes and the
            Scheduled Tribes (Prevention of Atrocities) Act, 1989 to support
            grievance redressal, dignity, safety, and equal opportunity for
            SC/ST students and staff.
          </p>
        </header>

        <!-- INTRO -->
        <section
          class="info-card"
          [class.dark-experience-area]="themeService.isDark()"
        >
          <div class="info-copy">
            <p>
              As per the Prevention of Atrocities Act, 1989 (No. 33 of 1989,
              dated 11-09-1989), an SC / ST Committee is constituted in
              Fatima Michael College of Engineering and Technology, Madurai.
            </p>

            <p>
              The committee is formed to align with AICTE expectations and to
              ensure that students and staff belonging to the SC/ST community
              are provided with a secure, respectful, and supportive campus
              environment.
            </p>

            <ul class="info-list">
              <li>
                To establish and uphold a safe, healthy, and supportive campus
                atmosphere for SC/ST staff and students.
              </li>
              <li>
                To address and resolve issues faced by staff and students from
                the SC/ST community in a fair and timely manner.
              </li>
              <li>
                To help prevent any form of discrimination, harassment, or
                violence within the scope of the Act.
              </li>
              <li>
                Affected SC/ST students and staff may approach this committee
                with complaints covered under the provisions of the Act.
              </li>
            </ul>
          </div>
        </section>

        <!-- COMMITTEE -->
        <section class="panel-card">
          <div class="panel-head">
            <div>
              <span class="panel-tag">Institution Committee</span>
              <h2>SC / ST Committee</h2>
            </div>

            <a
              class="pdf-link"
              href="assets/img/pdf/MOM-SC,SC-Committee.pdf"
              target="_blank"
              rel="noopener"
            >
              Open PDF
            </a>
          </div>

          <div class="row g-4 align-items-start">
            <div class="col-lg-4 col-md-12">
              <div class="pdf-card">
                <a
                  href="assets/img/pdf/MOM-SC,SC-Committee.pdf"
                  target="_blank"
                  rel="noopener"
                >
                  <img
                    src="assets/img/pdf/MOM-SCST.jpg"
                    class="pdf-image"
                    alt="SC / ST Committee PDF preview"
                    loading="lazy"
                  />
                </a>
                <div class="pdf-caption">Committee resolution / PDF preview</div>
              </div>
            </div>

            <div class="col-lg-8 col-md-12">
              <div class="table-wrap">
                <table class="table committee-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Member Name</th>
                      <th>Designation</th>
                      <th>Position</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let m of committeeMembers; trackBy: trackBySno">
                      <td>{{ m.sno }}</td>
                      <td>{{ m.memberName }}</td>
                      <td>{{ m.designation }}</td>
                      <td>{{ m.position }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</div>